export const materials = [
    {
        id: 1,
        name: "Ներածություն",
        info: "Դիտել",
        file: "../../files/information/laboratory/1.pdf",
        menuItemId: 1
    },
    {
        id: 2,
        name: "ARDUINO ՏՊԱՍԱԼԻ ԵՎ ՍԵՆՍՈՐՆԵՐԻ ՀԵՏ ԱՇԽԱՏԵԼՈՒ ԱՆՎՏԱՆԳՈՒԹՅԱՆ ԿԱՆՈՆՆԵՐ",
        info: "Դիտել",
        file: "../../files/information/laboratory/2.pdf",
        menuItemId: 1
    },
    {
        id: 3,
        name: "SMART ROBOT CAR KIT–Ի ՀԵՏ ԱՇԽԱՏԵԼՈՒ ԱՆՎՏԱՆԳՈՒԹՅԱՆ ԿԱՆՈՆՆԵՐ",
        info: "Դիտել",
        file: "../../files/information/laboratory/3.pdf",
        menuItemId: 1
    },
    {
        id: 4,
        name: "CREALITY 3D ՏՊԻՉԻ ՀԵՏ ԱՇԽԱՏԵԼՈՒ ԱՆՎՏԱՆԳՈՒԹՅԱՆ ԿԱՆՈՆՆԵՐ",
        info: "Դիտել",
        file: "../../files/information/laboratory/4.pdf",
        menuItemId: 1
    },
    {
        id: 5,
        name: "ԵՐԹՈՒՂԻՉԻ ԱՆՎՏԱՆԳՈՒԹՅԱՆ ԿԱՆՈՆՆԵՐ ԵՎ ՊԱՅՄԱՆՆԵՐ",
        info: "Դիտել",
        file: "../../files/information/laboratory/5.pdf",
        menuItemId: 1
    },
    {
        id: 6,
        name: "ԷԼԵԿՏՐՈՆԱՅԻՆ ՏԱՐՐԵՐԻ ՀԱՎԱՔԱԾՈՒ COLLECTION OF ELECTRONIC ELEMENTS",
        info: "Դիտել",
        file: "../../files/information/laboratory/6.pdf",
        menuItemId: 1
    },
    {
        id: 7,
        name: "ԹՎԱՅԻՆ ՄՈՒԼՏԻՄԵՏՐ",
        info: "Դիտել",
        file: "../../files/information/laboratory/1.pdf",
        menuItemId: 1
    },
    {
        id: 8,
        name: "RJ45 ԾԱԼՔԱՎՈՐ ՄԻԱԿՑԻՉ Connector Crimp Tool",
        info: "Դիտել",
        file: "../../files/information/laboratory/2.pdf",
        menuItemId: 1
    },
    {
        id: 9,
        name: "LED ԼՈՒՍԱԴԻՈԴԻ ՄԻԱՑՈՒՄ ARDUINO–Ի ՕԳՆՈՒԹՅԱՄԲ",
        info: "Դիտել",
        file: "../../files/information/laboratory/3.pdf",
        menuItemId: 1
    },
    {
        id: 10,
        name: "ԴԻՈԴԻ ՄԻԱՑՈՒՄ ԿԱՌԱՎԱՐՄԱՆ ԿՈՃԱԿՈՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/4.pdf",
        menuItemId: 1
    },
    {
        id: 11,
        name: "ՀԵՌԱՉԱՓԻ ԵՎ ԼՈՒՍԱԴԻՈԴԻ ԿԻՐԱՌՄԱՄԲ ՊԱՐԶԱԳՈՒՅՆ ՆԱԽԱԳԾԻ ՊԱՏՐԱՍՏՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/5.pdf",
        menuItemId: 1
    },
    {
        id: 12,
        name: "LED ԼՈՒՍԱԴԻՈԴԻ ՊԱՅԾԱՌՈՒԹՅԱՆ ԿԱՐԳԱՎՈՐՈՒՄ ՊՈՏԵՆՑԻՈՄԵՏՐԻ ՕԳՆՈՒԹՅԱՄԲ ",
        info: "Դիտել",
        file: "../../files/information/laboratory/6.pdf",
        menuItemId: 1
    },
    {
        id: 13,
        name: "ԳՈՒՆԱՅԻՆ ԷՖԵԿՏՆԵՐԻ ՍՏԱՑՈՒՄ ",
        info: "Դիտել",
        file: "../../files/information/laboratory/7.pdf",
        menuItemId: 1
    },
    {
        id: 14,
        name: "SERVO ՇԱՐԺԻՉԻ ՄԻԱՑՄԱՆ ԿԱՌԱՎԱՐՈՒՄԸ ԼՈՒՍԱԴԻՈԴԻ ԵՎ ՀԵՌԱՉԱՓԻ ՕԳՆՈՒԹՅԱՄԲ",
        info: "Դիտել",
        file: "../../files/information/laboratory/8.pdf",
        menuItemId: 1
    },
    {
        id: 15,
        name: "SERVO ՇԱՐԺԻՉԻ ՄԻԱՑՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/9.pdf",
        menuItemId: 1
    },
    {
        id: 16,
        name: "ԽՈՆԱՎՈՒԹՅԱՆ ԵՎ ՋԵՐՄԱՍՏԻՃԱՆԻ ՉԱՓՈՒՄ DHT11 ՍԵՆՍՈՐԻ ՕԳՆՈՒԹՅԱՄԲ ",
        info: "Դիտել",
        file: "../../files/information/laboratory/10.pdf",
        menuItemId: 1
    },
    {
        id: 17,
        name: "ՋՐԻ ՍԵՆՍՈՐԻ ՄԻԱՑՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/11.pdf",
        menuItemId: 1
    },
    {
        id: 18,
        name: "ԼՈՒՍԱՑՈՒՅՑԻ ՄՈԴԵԼԱՎՈՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/12.pdf",
        menuItemId: 1
    },
    {
        id: 19,
        name: "ԼՈՒՍԱԴԻՈԴԻ ՄԻԱՑՈՒՄ ՇԱՐԺՈՒՄ ՀԱՅՏՆԱԲԵՐԵԼՈՒ ԴԵՊՔՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/13.pdf",
        menuItemId: 1
    },
    {
        id: 20,
        name: "ԱԶԴԱՆՇԱՆԱՅԻՆ ՀԱՄԱԿԱՐԳ ԿՐԱԿԻ ՀԱՅՏՆԱԲԵՐՄԱՆ ԴԵՊՔՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/14.pdf",
        menuItemId: 1
    },
    {
        id: 21,
        name: "ՀՊՄԱՆ ՍԵՆՍՈՐԻ ԳՈՐԾԱՐԿՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/15.pdf",
        menuItemId: 1
    },
    {
        id: 22,
        name: "ՍՐՏԻ ԶԱՐԿԵՐԻ ԱՐՏԱՊԱՏԿԵՐՈՒՄ ԿՈՐԻ ՄԻՋՈՑՈՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/16.pdf",
        menuItemId: 1
    },
    {
        id: 23,
        name: "ԵՐԵՔ ԳՈՒՅՆԻ ԼՈՒՍԱԴԻՈԴԻ ԿԱՌԱՎԱՐՈՒՄ ՊՏՏՄԱՆ ՍԵՆՍՈՐԻ ՕԳՆՈՒԹՅԱՄԲ",
        info: "Դիտել",
        file: "../../files/information/laboratory/17.pdf",
        menuItemId: 1
    },
    {
        id: 24,
        name: "ՋՐԻ ՄԱԿԱՐԴԱԿԻ ՈՐՈՇՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/18.pdf",
        menuItemId: 1
    },
    {
        id: 25,
        name: "ՋՐԻ ՄԱԿԱՐԴԱԿՈՎ ՊԱՅՄԱՆԱՎՈՐՎԱԾ`ԼՈՒՍԱԴԻՈԴԻ ՄԻԱՑՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/19.pdf",
        menuItemId: 1
    },
    {
        id: 26,
        name: "ՁԱՅՆ ՍԵՆՍՈՐԻ ՄԻՋՈՑՈՎ LED ԼՈՒՍԱԴԻՈԴԻ ՄԻԱՑՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/20.pdf",
        menuItemId: 1
    },
    {
        id: 27,
        name: "ՄԱԳՆԻՍԿԱՆ ՍԵՆՍՈՐԻ ԳՈՐԾԱՐԿՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/21.pdf",
        menuItemId: 1
    },
    {
        id: 28,
        name: "ՋՈՅՍՏԻԿԻ ՕԳՆՈՒԹՅԱՄԲ SERVO ՇԱՐԺԻՉԻ ԿԱՌԱՎԱՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/22.pdf",
        menuItemId: 1
    },
    {
        id: 29,
        name: "ԽՈՉԸՆԴՈՏԻ ՀԱՅՏՆԱԲԵՐՄԱՆ ԻՆՖՐԱԿԱՐՄԻՐ ՍԵՆՍՈՐԻ ԳՈՐԾԱՐԿՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/23.pdf",
        menuItemId: 1
    },
    {
        id: 30,
        name: "ԳԾԻ ՃԱՆԱՉՄԱՆ ՍԵՆՍՈՐԻ ԳՈՐԾԱՐԿՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/24.pdf",
        menuItemId: 1
    },
    {
        id: 31,
        name: "ԻՐԱԿԱՆ ԺԱՄԱՆԱԿԻ ԺԱՄԱՑՈՒՅՑ",
        info: "Դիտել",
        file: "../../files/information/laboratory/25.pdf",
        menuItemId: 1
    },
    {
        id: 32,
        name: "ԷԿՐԱՆԻՆ 0-ԻՑ 9 ԹՎԵՐԻ, ՋԵՐՄԱՍՏԻՃԱՆԻ ԵՎ ՏԵՔՍՏԻ ԱՐՏԱԾՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/26.pdf",
        menuItemId: 1
    },
    {
        id: 33,
        name: "ՋԵՐՄԱՍՏԻՃԱՆԻ ՉԱՓՈՒՄ LM35D ԱՆԱԼՈԳԱՅԻՆ ՋԵՐՄԱՍՏԻՃԱՆԻ ՍԵՆՍՈՐԻ ՄԻՋՈՑՈՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/27.pdf",
        menuItemId: 1
    },
    {
        id: 34,
        name: "ՎԻԲՐԱՑԻՈՆ ՇԱՐԺԻՉԻ ԳՈՐԾԱՐԿՈՒՄ ՀԵՌԱՉԱՓԻ ՄԻՋՈՑՈՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/28.pdf",
        menuItemId: 1
    },
    {
        id: 35,
        name: "ՏՎՅԱԼՆԵՐԻ ՍՏԱՑՈՒՄ ԻՆՖՐԱԿԱՐՄԻՐ ՍԵՆՍՈՐԻ ՕԳՆՈՒԹՅԱՄԲ",
        info: "Դիտել",
        file: "../../files/information/laboratory/29.pdf",
        menuItemId: 1
    },
    {
        id: 36,
        name: "ԻՆՖՐԱԿԱՐՄԻՐ ՍԵՆՍՈՐԻ ՕԳՆՈՒԹՅԱՄԲ SERVO ՇԱՐԺԻՉԻ ՀԵՌԱԿԱՌԱՎԱՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/30.pdf",
        menuItemId: 1
    },
    {
        id: 37,
        name: "ԱՆԱԼՈԳԱՅԻՆ ՋԵՐՄԱՍՏԻՃԱՆԻ ՍԵՆՍՈՐՈՎ ՋԵՐՄԱՍՏԻՃԱՆԻ ՉԱՓՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/31.pdf",
        menuItemId: 1
    },
    {
        id: 38,
        name: "ԼՈՒՅՍԻ ԻՆՏԵՆՍԻՎՈՒԹՅԱՆ ԱՐԺԵՔԻ ԱՐՏԱԾՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/32.pdf",
        menuItemId: 1
    },
    {
        id: 39,
        name: "ԼՈՒՍԱՎՈՐՈՒԹՅԱՆ ՄԻԱՑՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/33.pdf",
        menuItemId: 1
    },
    {
        id: 40,
        name: "ՀԱՐՎԱԾԻ ՀԱՅՏՆԱԲԵՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/34.pdf",
        menuItemId: 1
    },
    {
        id: 41,
        name: "ԱԿՏԻՎ ԵՎ ՊԱՍԻՎ ԱԶԴԱՆՇԱՆԱՅԻՆ ՍԵՆՍՈՐԱՅԻՆ ՄՈԴՈՒԼՆԵՐ",
        info: "Դիտել",
        file: "../../files/information/laboratory/35.pdf",
        menuItemId: 1
    },
    {
        id: 42,
        name: "ԹԵՔՈՒԹՅԱՆ ՀԱՅՏՆԱԲԵՐՄԱՆ ՍԵՆՍՈՐՆԵՐ",
        info: "Դիտել",
        file: "../../files/information/laboratory/36.pdf",
        menuItemId: 1
    },
    {
        id: 43,
        name: "ՀՈՂԻ ԽՈՆԱՎՈՒԹՅԱՆ ՉԱՓՈՒՄ ՀՈՂԻ ԽՈՆԱՎՈՒԹՅԱՆ ՍԵՆՍՈՐՈՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/37.pdf",
        menuItemId: 1
    },
    {
        id: 44,
        name: "ՄԱՏՐԻՑԱՅԻՆ ՍՏԵՂՆԱՇԱՐՈՎ ՏԵՂԵԿՈՒՅԹԻ ԱՐՏԱԾՈՒՄ ՍԵՐԻԱԼ ՄՈՆԻՏՈՐԻՆ ",
        info: "Դիտել",
        file: "../../files/information/laboratory/38.pdf",
        menuItemId: 1
    },
    {
        id: 45,
        name: "IIC 1602 LCD ՄԻՋՈՑՈՎ ՏԵՂԵԿՈՒՅԹԻ ԱՐՏԱԾՈՒՄ ԷԿՐԱՆԻՆ",
        info: "Դիտել",
        file: "../../files/information/laboratory/39.pdf",
        menuItemId: 1
    },
    {
        id: 46,
        name: "ԱՇԽԱՏԱՆՔ WI-FI ԵՐԹՈՒՂԻՉԻ ՀԵՏ",
        info: "Դիտել",
        file: "../../files/information/laboratory/40.pdf",
        menuItemId: 1
    },
    {
        id: 47,
        name: "WIFI ROUTER-Ի ԿԱՐԳԱԲԵՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/41-42.pdf",
        menuItemId: 1
    },
    {
        id: 48,
        name: "WIFI ROUTER-Ի ԿԱՐԳԱԲԵՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/41-42.pdf",
        menuItemId: 1
    },
    {
        id: 48,
        name: "ԱՇԽԱՏԱՆՔ ՌՈԲՈՏ-ՏԱՆԿԻ ՀԵՏ: ԴՐԱՅՎԵՐԻ ՏԵՂԱԴՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/43.pdf",
        menuItemId: 1
    },
    {
        id: 49,
        name: "ԼՈՒՅՍԻ ԹԱՐԹՈՒՄ (LED BLINK )",
        info: "Դիտել",
        file: "../../files/information/laboratory/44.pdf",
        menuItemId: 1
    },
    {
        id: 50,
        name: "BLUETOOTH–Ի ՄԻՋՈՑՈՎ ԼՈՒՅՍԻ ՄԻԱՑՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/45.pdf",
        menuItemId: 1
    },
    {
        id: 51,
        name: "ԼՈՒՅՍԻ ԿԱՌԱՎԱՐՈՒՄ ՖՈՏՈՌԵԶԻՍՏՈՐԻ ՄԻՋՈՑՈՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/46.pdf",
        menuItemId: 1
    },
    {
        id: 52,
        name: "ԱՇԽԱՏԱՆՔ ՇԱՐԺԻՉՆԵՐԻ ՀԵՏ ԵՎ ԱՐԱԳՈՒԹՅԱՆ ԿԱՌԱՎԱՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/47.pdf",
        menuItemId: 1
    },
    {
        id: 53,
        name: "ՊԱՏՆԵՇԻՑ ԽՈՒՍԱՓՈՂ ՌՈԲՈՏ",
        info: "Դիտել",
        file: "../../files/information/laboratory/48.pdf",
        menuItemId: 1
    },
    {
        id: 54,
        name: "SERVO ՇԱՐԺԻՉՈՎ ԿԱՌԱՎԱՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/49.pdf",
        menuItemId: 1
    },
    {
        id: 55,
        name: "ԱՇԽԱՏԱՆՔ ԵՌԱՉԱՓ ՏՊԻՉՈՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/50.pdf",
        menuItemId: 1
    },
    {
        id: 56,
        name: "ՄՈԴԵԼԻ ՊԱՏՐԱՍՏՈՒՄ ԵՎ ՏՊԱԳՐՈՒՄ",
        info: "Դիտել",
        file: "../../files/information/laboratory/51.pdf",
        menuItemId: 1
    },
    {
        id: 57,
        name: "ԵՌԱՉԱՓ ՄՈԴԵԼԻ ՊԱՏՐԱՍՏՈՒՄ FREECAD ԾՐԱԳՐՈՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/52.pdf",
        menuItemId: 1
    },
    {
        id: 58,
        name: "ԵՌԱՉԱՓ ՏՊԻՉՈՎ ՏՊԱԳՐՈՒԹՅԱՆ ՔԱՅԼԵՐԸ",
        info: "Դիտել",
        file: "../../files/information/laboratory/53.pdf",
        menuItemId: 1
    },
    {
        id: 59,
        name: "ԼԵՌԱՉԱՓ ՄՈԴԵԼԻ ՊԱՏՐԱՍՏՈՒՄ TINKERCAD ԱՌՑԱՆՑ ԳՈՐԾԻՔՎ",
        info: "Դիտել",
        file: "../../files/information/laboratory/54.pdf",
        menuItemId: 1
    },
];


